// CSS Modules - component class name prefix: NewsletterQuickSubscription__

<template>
  <div
    :class="[
      $style.container,
      'column',
      'is-half-tablet',
      'is-one-quarter-desktop'
    ]"
  >
    <h3 class="Footer__title">{{ config.title }}</h3>
    <p>{{ config.text }}</p>
    <div :class="$style.newsletterForm">
      <input
        id="newsletter-email"
        name="newsletter-email"
        data-origval=""
        class="origVal"
        :placeholder="config.placeholder"
        type="email"
        :disabled="checkIsNewsletterUrlMissing"
        :class="$style.emailInput"
        v-model="newsletterEmailAdress"
      />
      <div :class="$style.submitContainer">
        <button
          id="navigateToNewsletterFormBtn"
          value=""
          :class="$style.submitButton"
          :disabled="checkIsNewsletterUrlMissing"
          @click="navigateToNewsletterForm"
        />
        <i class="fas fa-caret-right"></i>
      </div>
      <div v-if="newsletterEmailAdressInvalid" :class="$style.errorMessage">
        {{ config.errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { Email } from "../../globals/constants/validation";

export default {
  name: "NewsletterQuickSubscription",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      newsletterEmailAdress: "",
      newsletterEmailAdressInvalid: false
    };
  },
  methods: {
    navigateToNewsletterForm() {
      this.newsletterEmailAdressInvalid = !this.checkIsEmailValid();
      if (!this.newsletterEmailAdressInvalid) {
        window.location = `${this.config.newsletterFormUrl}?email=${
          this.newsletterEmailAdress
        }`;
      }
    },
    checkIsEmailValid() {
      return (
        this.newsletterEmailAdress &&
        Email.REGEX.test(this.newsletterEmailAdress)
      );
    }
  },
  computed: {
    checkIsNewsletterUrlMissing() {
      return !this.config.newsletterFormUrl;
    }
  }
};
</script>

<style module lang="scss">
@import "./NewsletterQuickSubscription.scss";
</style>
